"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Spinner = props => {
  return (0, _jsxRuntime.jsx)("div", {
    css: theme => [_styles.styles.default(theme), props.size && _styles.styles.size(props.size), props.margin && _styles.styles.margin(props.margin), props.color && _styles.styles.color(props.color), (props.thickness || props.offsetColor) && _styles.styles.border(props.thickness, props.offsetColor, props.color || theme.primary)],
    role: "alert",
    "aria-live": "polite",
    "aria-label": "Laster..."
  });
};
var _default = exports.default = Spinner;